import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-history-dialog',
  templateUrl: './history-dialog.component.html',
  styleUrls: ['./history-dialog.component.scss']
})
export class HistoryDialogComponent implements OnInit {

  label: string;
  values: any[];
  regex = /\s/g;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<HistoryDialogComponent>) { }

  ngOnInit() {
    this.label = this.data.label;
    this.values = this.data.values;
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/history-dialog.component.ts